import i18nInstance from 'i18n/i18nInstance'
import { Product } from '@mc/api'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'
import { TrackingContainer } from '@mc/visibility'
import { trackDecreaseStandardPriceEV } from 'experiments/prcng-861_v1_decrease_standard_price'
import { Prcng1079CancelAnswerWrapper } from 'experiments/prcng-1079_v1_remove_refund_copy'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetPricingSectionProps = {
  isCheckoutPage?: boolean
  annualPass?: Product
  isEntryPaintedDoorVariant?: boolean
}

/**
 * Tracking for price change experiments.
 * Eg. tracking experiment view
 */
const onPricingSectionPriceVisible = () => {
  trackDecreaseStandardPriceEV()
}

export const getPricingSection: (props: GetPricingSectionProps) => Section = ({
  isCheckoutPage,
  annualPass,
}: GetPricingSectionProps) => {
  const priceWithDiscount = annualPass?.monetizedFlatRateTotal
  const hasDiscount =
    priceWithDiscount && annualPass?.monetizedFlatRate !== priceWithDiscount

  return {
    title: t('faq.pricing.title'),
    questions: [
      {
        title: t('faq.pricing.question1'),
        uuid: 'faq.pricing.question1',
        answer: (
          <TrackingContainer onFirstVisible={onPricingSectionPriceVisible}>
            <Trans
              i18nKey={`faq.pricing.answer1.${hasDiscount ? 'discount' : 'string'}`}
              values={{
                price: hasDiscount ? priceWithDiscount : annualPass?.price,
                strikeThroughPrice: annualPass?.monetizedFlatRate,
              }}
              ns='@mc/next'
            >
              <span className='mc-opacity--hinted mc-text--strike' />
            </Trans>
          </TrackingContainer>
        ),
        hide: !annualPass?.price || isCheckoutPage,
      },
      {
        title: t('faq.pricing.question2'),
        uuid: 'faq.pricing.question2',
        answer: (
          <Trans i18nKey='faq.pricing.answer2' ns='@mc/next'>
            <p className='mc-opacity--hinted' />
            <br />
            <p className='mc-opacity--hinted'>
              <a className='mc-text--link' href={paths.helpCenter} />
            </p>
          </Trans>
        ),
      },
      {
        title: t('faq.pricing.question3'),
        uuid: 'faq.pricing.question3.string',
        answer: (
          <Trans i18nKey='faq.pricing.answer3' ns='@mc/next'>
            <p className='mc-opacity--hinted'>
              <a className='mc-text--link' href={paths.supportGetRefund} />
            </p>
          </Trans>
        ),
      },
      {
        title: t('faq.pricing.question4'),
        uuid: 'faq.pricing.question4.string',
        // prcng-1079_v1 — removes the partial-refund sentence in variant_1.
        answer: <Prcng1079CancelAnswerWrapper />,
      },
    ],
  }
}
